import React from 'react';
import { View } from 'react-native';
import _ from 'lodash';
import { FlexElement, Heading4, MetricStackTitle, ShinyBlockOuter, ShinyBody, ShinyHeading, BasicText as Text } from '../../Styles';
import { OpidFlatList } from '../../core';
import moment from 'moment';
import Util from '../../core/Util';

const Alert = ({alert}) => {
    return <View style={{flexDirection: "column", marginBottom: 15, alignItems: "stretch"}} key={alert.task_id}>
        <View style={{flexDirection: "row"}}>
            <Heading4 weight="bold" style={{flex: 1, textAlign: "left"}}>{alert.task_type}</Heading4>
            <Text style={{display: "flex", flex: 1, textAlign: "center"}}>{alert.short_description}</Text>
            <Text style={{flex: 1, textAlign: "right"}}>{moment(alert.created_at).fromNow()}</Text>
        </View>
        <View style={{flexDirection: "row", justifyContent: "space-between"}}>
            <Text>{alert.body}</Text>
            <Text>{alert.created_by}</Text>
        </View>
    </View>;
}

const Alerts = ({site, alerts}) => {
    return <ShinyBlockOuter flexBasis={Util.isMobile()? "100%": "99%"} style={{marginHorizontal: 0}}>
        <ShinyHeading>
            <MetricStackTitle>Recent Activity</MetricStackTitle>
        </ShinyHeading>
        <ShinyBody>
            <OpidFlatList
                data={alerts}
                renderItem={ (item)=><Alert alert={item} /> }
                style={{padding: Util.isMobile()? 0 : 13}}
            />
        </ShinyBody>
    </ShinyBlockOuter>;
}

export default Alerts;